<template>
 <div>
    <el-row>
        <el-col v-for="(item,index) in iconArr" :key="index" :span="4" v-if="item.state" class="textcenter padtb10"><div class="" ><img class="icon56" :src="item.url" alt=""></div><div class="font14 col333">{{item.name}}</div></el-col>
    </el-row>
 </div>
</template>

<script>
 export default {
   data () {
     return {
        iconArr:[{name:'空调',url:'../../static/img/images/kt.png',state:false},
        {name:'洗衣机',url:'../../static/img/images/xyj.png',state:false},
        {name:'电视',url:'../../static/img/images/tv.png',state:false},
        {name:'冰箱',url:'../../static/img/images/bx.png',state:false},
        {name:'沙发',url:'../../static/img/images/safa.png',state:false},
        {name:'餐桌',url:'../../static/img/images/cz.png',state:false},
        {name:'床',url:'../../static/img/images/bed.png',state:false},
        {name:'工位',url:'../../static/img/images/gw.png',state:false},
        {name:'会议室',url:'../../static/img/images/hyz.png',state:false},
        {name:'老板桌',url:'../../static/img/images/boss.png',state:false},
        {name:'植物',url:'../../static/img/images/tree.png',state:false},
        {name:'前台',url:'../../static/img/images/qt.png',state:false}]
        }
   },
   props:['list'],
   watch:{
     list(val){
       let listArr=[];
       for (let i = 0; i < val.length; i++) {
        listArr.push(this.commonfun.getDictLabel('dictConf',val[i]))
       }
      console.log(listArr);
      this.iconArr.forEach(item => {
        listArr.forEach(it => {
        if(item.name==it){
          item.state=true
        }
      });
      });

     }
   },
   components: {

   },
   methods: {

   }
 }
</script>

<style  lang="scss">
.icon56{
  width: 30px;
  height: 30px;
}

</style>



// WEBPACK FOOTER //
// src/components/officeFacilities.vue